export const linkStyle = {
  textDecoration: "none",
};
export const details = {
  fontSize: "1.3rem",
};
